import { IonReactRouter } from '@ionic/react-router';
import { FC, useCallback, useContext, useEffect } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router';
import { AppContext } from '../lib/context/AppContext';
import AuthRoutes from './auth/AuthRoutes';
import AuthenticatedRoutes from './authenticated/AuthenticatedRoutes';
import { isPlatform, useIonToast } from '@ionic/react';
import { notificationsCircleOutline } from 'ionicons/icons';
import PublicRoutes from './public/PublicRoutes';
import SupportPage from './public/SupportPage';
import HomePage from './public/HomePage';

const Root: FC = (props: any) => {
  const { user, isLoading } = useContext(AppContext);
  const [present] = useIonToast();

  useEffect(() => {
    openNotificationForegroundHandler();
    openNotificationHandler();
  }, []);

  /**
   * Open notification foreground
   */

  const openNotificationForegroundHandler = useCallback(() => {
    window.document.addEventListener('showForegroundNotification', (e: any) => {
      let data = getDataFromNotification(e.detail);

      present({
        icon: notificationsCircleOutline,
        header: data.modelTitle,
        message: data.modelMessage,
        color: 'primary',
        duration: 2500,
        position: 'top',
        layout: 'stacked',
        buttons: [
          {
            text: 'Apri',
            handler: () => {
              goToNotification(data.modelType, data.modelId);
            },
          },
        ],
      });
    });
  }, []);

  /**
   * Open notification
   */
  const openNotificationHandler = useCallback(() => {
    window.document.addEventListener('openNotification', (e: any) => {
      let data = getDataFromNotification(e.detail);

      goToNotification(data.modelType, data.modelId);
    });
  }, []);

  /**
   * Get data from event
   */
  const getDataFromNotification = useCallback((detail: any): any => {
    let data = {
      modelTitle: '',
      modelMessage: '',
      modelType: '',
      modelId: null,
    };
    if (detail.internalLink) {
      data = detail;
    } else {
      if (isPlatform('android')) {
        data.modelTitle = detail.additionalData?.title;
        data.modelMessage = detail.additionalData?.message;
        data.modelType = detail.additionalData?.type;
        data.modelId = detail.additionalData?.id;
      } else if (isPlatform('ios')) {
        data.modelTitle = detail.rawPayload?.custom?.a?.title;
        data.modelMessage = detail.rawPayload?.custom?.a?.message;
        data.modelType = detail.rawPayload?.custom?.a?.type;
        data.modelId = detail.rawPayload?.custom?.a?.id;
      }
    }

    return data;
  }, []);

  /**
   * Click on notification and open page
   */
  const goToNotification = useCallback((modelType: string, modelId: number) => {
    switch (modelType) {
      case 'event':
        window.location.href = `/events/${modelId}`;
        break;
      case 'promo':
        window.location.href = `/promos/${modelId}`;
        break;
      case 'trip':
        window.location.href = `/trips/${modelId}`;
        break;
      case 'announcement':
        window.location.href = `/news/${modelId}`;
        break;
      default:
        break;
    }
  }, []);

  return (
    <>
      <IonReactRouter>
        <Switch>
          <Route path={'/auth'}>
            <AuthRoutes />
          </Route>

          <Route path={'/*'}>
            <Switch>
              <Route exact={true} path={`/support`}>
                <SupportPage />
              </Route>

              {/* {!user && !isLoading && <Redirect to='/auth' />} */}
              <AuthenticatedRoutes />
            </Switch>
          </Route>
        </Switch>
      </IonReactRouter>
    </>
  );
};

export default Root;
